import moment from 'moment'

import {
  AddressQuestion,
  BooleanQuestion,
  DateQuestion,
  PhoneQuestion,
  Question,
  Questions,
} from '../../classes'
import { Countries } from '../../data'

export const getAccidentQuestions = (customQuestions: Questions): Questions => [
  new BooleanQuestion({
    label: 'patient-intake.accident-section.field-procedure-auto-accident',
    key: 'isAutoAccidentRelated',
    hint: 'patient-intake.accident-section.field-procedure-auto-accident-hint',
    introText:
      'patient-intake.accident-section.field-procedure-auto-accident-text',
    required: true,
    ifNoProceed: true,
    ifQuestions: getAutoQuestions(),
  }),

  new BooleanQuestion({
    label: 'patient-intake.accident-section.field-procedure-workplace',
    key: 'isWorkersCompensationRelated',
    hint: 'patient-intake.accident-section.field-procedure-workplace-hint',
    introText: 'patient-intake.accident-section.field-procedure-workplace-text',
    required: true,
    ifNoProceed: true,
    ifQuestions: getWorkersCompQuestions(),
  }),

  ...customQuestions,
]

const getAutoQuestions = (): Questions => [
  new Question({
    label: 'patient-intake.accident-section.field-insurance-provider',
    key: 'autoInsuranceProvider',
    hint: 'patient-intake.accident-section.field-insurance-provider-hint',
    flex: '50',
  }),

  new Question({
    label: 'patient-intake.accident-section.field-policy-number',
    key: 'autoPolicyNumber',
    hint: 'patient-intake.accident-section.field-policy-number-hint',
    flex: '50',
  }),

  new Question({
    label: 'patient-intake.accident-section.field-claim-number',
    key: 'autoClaimNumber',
    flex: '50',
  }),

  new DateQuestion({
    label: 'patient-intake.accident-section.field-date',
    key: 'dateOfAccident',
    flex: '50',
    max: moment().format('YYYY-MM-DD'),
  }),

  new AddressQuestion({
    label: 'patient-intake.accident-section.field-address',
    hint: 'patient-intake.accident-section.field-address-hint',
    key: 'autoInsuranceAddress',
    options: Countries,
  }),

  new PhoneQuestion({
    label: 'patient-intake.accident-section.field-phone-number',
    hint: 'patient-intake.accident-section.field-phone-number-hint',
    key: 'autoInsurancePhoneNumber',
  }),

  new Question({
    label: 'patient-intake.accident-section.field-adjuster-name',
    key: 'autoAdjusterName',
  }),
]

const getWorkersCompQuestions = (): Questions => [
  new DateQuestion({
    label: 'patient-intake.accident-section.field-procedure-workplace-date',
    key: 'dateOfWorkplaceAccident',
    flex: '50',
    max: moment().format('YYYY-MM-DD'),
  }),

  new Question({
    label:
      'patient-intake.accident-section.field-procedure-workplace-insurance-provider',
    key: 'workersCompInsuranceProvider',
    flex: '50',
  }),

  new AddressQuestion({
    label: 'patient-intake.accident-section.field-procedure-workplace-address',
    key: 'workAddress',
    options: Countries,
  }),

  new PhoneQuestion({
    label:
      'patient-intake.accident-section.field-procedure-workplace-phone-number',
    key: 'workPhoneNumber',
    flex: '50',
  }),

  new Question({
    label:
      'patient-intake.accident-section.field-procedure-workplace-supervisor-name',
    key: 'workSupervisorName',
    flex: '50',
  }),

  new Question({
    label:
      'patient-intake.accident-section.field-procedure-workplace-claim-number',
    key: 'workClaimNumber',
    flex: '50',
  }),

  new Question({
    label:
      'patient-intake.accident-section.field-procedure-workplace-adjusters-name',
    key: 'workAdjustersName',
    flex: '50',
  }),

  new PhoneQuestion({
    label:
      'patient-intake.accident-section.field-procedure-workplace-adjusters-phone',
    key: 'workAdjustersPhoneNumber',
    flex: '100',
  }),
]
